import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

export const UBItem = ({ styles, children }) => {
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: 'transparent',
        color: 'white',
        boxSizing: 'border-box',
        height: "100%",
        padding: 5,
        ...styles
    }));

    return (
        <Item>
            {children}
        </Item>
    );
}